var _path, _path2, _path3, _path4, _rect, _g, _circle, _path5, _rect2, _rect3, _g2, _path6, _path7, _path8, _path9, _circle2, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgFullDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 82,
    viewBox: "0 0 236 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 20.5681V6.13261C1.875 3.29795 4.17295 1 7.00762 1H21.7639",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 60.6663V75.1018C1.875 77.9364 4.17295 80.2344 7.00762 80.2344H21.7639",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.734 20.5681V6.13261C107.734 3.29795 105.436 1 102.602 1H87.8455",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.734 60.6663V75.1018C107.734 77.9364 105.436 80.2344 102.602 80.2344H87.8455",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5171_93382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 10,
    width: 86,
    height: 61
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9994,
    y: 11.3822,
    width: 83.5407,
    height: 58.47,
    rx: 5.535,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5171_93382)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.1953,
    y: 12.1172,
    width: 89.4511,
    height: 59.4385,
    rx: 4.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3671 60.5834H42.9635C44.5922 60.5834 45.9172 59.207 45.9172 57.5161V41.3993C45.9172 39.7084 44.5921 38.332 42.9635 38.332H24.3671C22.7392 38.332 21.4141 39.7084 21.4141 41.3993V57.5161C21.4141 59.207 22.7392 60.5834 24.3671 60.5834ZM39.0192 58.9809H28.3122V57.8878C28.3122 55.9182 29.3106 54.1962 30.8017 53.2084C31.6443 53.7486 32.6224 54.0641 33.669 54.0641C34.7134 54.0641 35.6893 53.7492 36.5305 53.21C38.021 54.198 39.0192 55.919 39.0192 57.888V58.9809ZM29.5371 47.8867C29.5371 45.3594 31.391 43.3039 33.669 43.3039C35.9433 43.3039 37.7941 45.3594 37.7941 47.8867C37.7941 50.4093 35.9433 52.4616 33.669 52.4616C31.3911 52.4616 29.5371 50.4092 29.5371 47.8867ZM22.9569 41.3993C22.9569 40.5917 23.5897 39.9345 24.3671 39.9345H42.9635C43.7416 39.9345 44.3745 40.5917 44.3745 41.3993V57.5161C44.3745 58.3237 43.7417 58.9809 42.9635 58.9809H40.5618V57.8878C40.5618 55.5344 39.4542 53.4548 37.7618 52.1484C38.7351 51.0387 39.337 49.5391 39.337 47.8865C39.337 44.4759 36.7945 41.7012 33.669 41.7012C30.5397 41.7012 27.9943 44.4757 27.9943 47.8865C27.9943 49.537 28.5955 51.0346 29.5675 52.1439C27.874 53.4496 26.7694 55.5336 26.7694 57.8878V58.9809H24.3671C23.5897 58.9809 22.9569 58.3237 22.9569 57.5161V41.3993Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2522 38.9414H54.6792C54.2389 38.9414 53.8828 39.2823 53.8828 39.7034C53.8828 40.1247 54.2391 40.4655 54.6792 40.4655H76.2522C76.6925 40.4655 77.0486 40.1246 77.0486 39.7034C77.0486 39.2823 76.6925 38.9414 76.2522 38.9414Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2522 42.5996H54.6792C54.2389 42.5996 53.8828 42.9405 53.8828 43.3616C53.8828 43.7829 54.2391 44.1237 54.6792 44.1237H76.2522C76.6925 44.1237 77.0486 43.7828 77.0486 43.3616C77.0486 42.9405 76.6925 42.5996 76.2522 42.5996Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1869 48.6953H54.6803C54.2394 48.6953 53.8828 49.0362 53.8828 49.4573C53.8828 49.8786 54.2396 50.2194 54.6803 50.2194H91.1869C91.6278 50.2194 91.9844 49.8785 91.9844 49.4573C91.9844 49.0361 91.6278 48.6953 91.1869 48.6953Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1869 54.791H54.6803C54.2394 54.791 53.8828 55.1319 53.8828 55.553C53.8828 55.9743 54.2396 56.3151 54.6803 56.3151H91.1869C91.6278 56.3151 91.9844 55.9742 91.9844 55.553C91.9844 55.1318 91.6278 54.791 91.1869 54.791Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6211 6.78006C90.3362 7.05066 94.4908 7.55071 98.1379 8.31131C99.9613 8.69158 101.671 9.13981 103.14 9.66227C104.6 10.1813 105.869 10.7887 106.779 11.5079C107.687 12.2256 108.343 13.1447 108.305 14.2707C108.268 15.3686 107.574 16.4128 106.407 17.4113C104.07 19.4099 99.3304 21.6544 91.3811 24.2081C75.9742 29.1573 58.4874 29.515 42.6761 27.8967C26.8588 26.2779 12.6631 22.6754 3.80689 19.6583C2.27986 19.138 1.09867 17.96 0.519925 16.4756L0.380414 16.1161C-0.906763 12.8143 1.18677 9.18006 4.68289 8.64788L35.8522 3.90403C36.235 3.84575 36.6234 3.82729 37.0102 3.85014L86.6211 6.78006Z",
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9717 18.0889C33.9864 18.089 37.2012 21.4432 37.2012 25.5303C37.2011 29.6172 33.9864 32.9705 29.9717 32.9707C25.9568 32.9707 22.7413 29.6173 22.7412 25.5303C22.7412 21.4431 25.9568 18.0889 29.9717 18.0889Z",
    fill: "#51E1CE",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9994,
    y: 11.3822,
    width: 83.5407,
    height: 58.47,
    rx: 5.535,
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.0081,
    cy: 11.7561,
    r: 7.52371,
    fill: "#ECFDF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8438 4.05078C95.2306 4.05078 93.6537 4.51264 92.3124 5.37796C90.9711 6.24327 89.9257 7.47318 89.3084 8.91215C88.691 10.3511 88.5295 11.9345 88.8442 13.4621C89.1589 14.9897 89.9357 16.3929 91.0764 17.4942C92.2171 18.5956 93.6704 19.3456 95.2525 19.6495C96.8347 19.9533 98.4747 19.7974 99.965 19.2013C101.455 18.6053 102.729 17.5959 103.625 16.3009C104.522 15.0059 105 13.4833 105 11.9258C105 9.8372 104.141 7.83416 102.611 6.35732C101.081 4.88047 99.0069 4.05078 96.8438 4.05078ZM95.6786 15.0706L92.7656 12.2581L93.6923 11.3633L95.6786 13.281L99.9956 9.11328L100.925 10.0054L95.6786 15.0706Z",
    fill: "#00D492"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5171_93382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 9,
    width: 93,
    height: 65
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 135.266,
    y: 9,
    width: 92,
    height: 65,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5171_93382)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5171_93382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: -12,
    width: 98,
    height: 83
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 145.801,
    y: -12.3238,
    width: 83.5407,
    height: 58.47,
    rx: 5.535,
    transform: "rotate(19.8622 145.801 -12.3238)",
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5171_93382)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.914,
    y: -12.5859,
    width: 89.4511,
    height: 59.4385,
    rx: 4.8,
    transform: "rotate(19.8622 142.914 -12.5859)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.772 37.8119L157.262 44.1301C158.794 44.6835 160.508 43.8392 161.082 42.2489L166.558 27.0908C167.133 25.5005 166.354 23.7558 164.822 23.2025L147.332 16.8842C145.801 16.3311 144.087 17.1753 143.513 18.7657L138.037 33.9237C137.462 35.514 138.241 37.2587 139.772 37.8119ZM154.097 41.2829L144.027 37.6451L144.398 36.617C145.067 34.7646 146.591 33.4842 148.329 33.0618C148.938 33.8561 149.751 34.4852 150.735 34.8408C151.718 35.1956 152.743 35.2311 153.717 35.0098C154.783 36.4454 155.137 38.4032 154.468 40.2549L154.097 41.2829ZM148.948 27.627C149.807 25.2501 152.249 23.9467 154.391 24.7207C156.53 25.4934 157.573 28.0555 156.714 30.4324C155.857 32.805 153.419 34.1063 151.28 33.3336C149.138 32.5597 148.091 29.9994 148.948 27.627ZM144.964 19.2898C145.238 18.5303 146.056 18.1272 146.788 18.3913L164.278 24.7096C165.01 24.974 165.382 25.8072 165.107 26.5667L159.631 41.7248C159.357 42.4843 158.538 42.8874 157.807 42.623L155.548 41.807L155.919 40.7789C156.719 38.5656 156.384 36.2334 155.236 34.4296C156.528 33.7167 157.604 32.5107 158.165 30.9564C159.324 27.7487 157.876 24.2753 154.936 23.2134C151.993 22.1501 148.656 23.8948 147.497 27.1026C146.936 28.6549 146.993 30.2678 147.53 31.6414C145.494 32.2939 143.747 33.8787 142.947 36.0928L142.576 37.1209L140.316 36.3047C139.585 36.0405 139.213 35.2074 139.488 34.4479L144.964 19.2898Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.929 35.0885L175.64 27.7589C175.226 27.6093 174.775 27.8089 174.632 28.205C174.489 28.6012 174.708 29.0427 175.122 29.1923L195.411 36.5219C195.826 36.6715 196.276 36.4718 196.419 36.0758C196.562 35.6797 196.343 35.2381 195.929 35.0885Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.687 38.528L174.397 31.1983C173.983 31.0487 173.533 31.2484 173.39 31.6444C173.246 32.0406 173.466 32.4822 173.88 32.6317L194.169 39.9614C194.583 40.1109 195.034 39.9113 195.177 39.5152C195.32 39.1192 195.101 38.6775 194.687 38.528Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.663 49.3365L172.328 36.9331C171.914 36.7833 171.462 36.9827 171.319 37.3788C171.176 37.775 171.396 38.2167 171.81 38.3665L206.145 50.7699C206.56 50.9197 207.011 50.7203 207.154 50.3242C207.297 49.928 207.078 49.4863 206.663 49.3365Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.593 55.0709L170.258 42.6674C169.843 42.5177 169.392 42.7171 169.249 43.1132C169.106 43.5094 169.326 43.9511 169.74 44.1008L204.075 56.5043C204.49 56.6541 204.941 56.4546 205.084 56.0586C205.227 55.6624 205.007 55.2207 204.593 55.0709Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.607 8.35943C220.009 9.8762 223.746 11.758 226.918 13.7125C228.504 14.6897 229.959 15.692 231.164 16.6827C232.36 17.6669 233.347 18.6692 233.959 19.6549C234.569 20.6383 234.874 21.7258 234.456 22.7718C234.048 23.7918 233.041 24.5382 231.603 25.0806C228.726 26.1664 223.506 26.6671 215.162 26.368C198.99 25.7881 182.422 20.1832 168.101 13.2892C153.775 6.39254 141.648 -1.81875 134.343 -7.66538C133.084 -8.67349 132.373 -10.1828 132.333 -11.7755L132.324 -12.161C132.235 -15.7037 135.439 -18.4105 138.908 -17.7232L169.835 -11.5947C170.215 -11.5195 170.586 -11.4049 170.942 -11.252L216.607 8.35943Z",
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.484 -0.250452C163.259 1.11376 165.143 5.36066 163.755 9.20457C162.366 13.0484 158.203 15.11 154.427 13.7461C150.651 12.382 148.766 8.13563 150.155 4.29166C151.544 0.447644 155.708 -1.61455 159.484 -0.250452Z",
    fill: "#51E1CE",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.801,
    y: -12.3238,
    width: 83.5407,
    height: 58.47,
    rx: 5.535,
    transform: "rotate(19.8622 145.801 -12.3238)",
    stroke: "#0F574E",
    strokeWidth: 1.47
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 20.5681V6.13261C128.266 3.29795 130.564 1 133.398 1H148.155",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 60.6663V75.1018C128.266 77.9364 130.564 80.2344 133.398 80.2344H148.155",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M234.125 20.5681V6.13261C234.125 3.29795 231.827 1 228.992 1H214.236",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.125 60.6663V75.1018C234.125 77.9364 231.827 80.2344 228.992 80.2344H214.236",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.214,
    cy: 11.5871,
    r: 7.37814,
    fill: "#ECFDF5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M223.053 4.0293C218.597 4.0293 215.055 7.44932 215.055 11.7519C215.055 16.0545 218.597 19.4745 223.053 19.4745C227.509 19.4745 231.052 16.0545 231.052 11.7519C231.052 7.44932 227.509 4.0293 223.053 4.0293ZM226.138 15.6132L223.053 12.6345L219.968 15.6132L219.054 14.7306L222.139 11.7519L219.054 8.7732L219.968 7.89061L223.053 10.8693L226.138 7.89061L227.052 8.7732L223.967 11.7519L227.052 14.7306L226.138 15.6132Z",
    fill: "#FF6467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFullDocument);
export default __webpack_public_path__ + "static/media/img-full-document.e0b670b6bb77e0676e50fac03af843f7.svg";
export { ForwardRef as ReactComponent };